<template>
  <div>
    <div class="is-clearfix">
      <nuxt-link
        class="button is-primary is-pulled-right"
        :to="localePath('office-products-glass-edge-processing-create')"
      >{{ $t("form.create") }}</nuxt-link>

      <nav class="breadcrumb" aria-label="breadcrumbs">
        <ul>
          <li>
            <nuxt-link :to="localePath('office-products')">
              {{
              $t("page.products")
              }}
            </nuxt-link>
          </li>
          <li>
            <nuxt-link :to="localePath('office-products-glass')">
              {{
              $t("page.glass")
              }}
            </nuxt-link>
          </li>

          <li class="is-active">
            <a aria-current="page">{{ $t('page.edge_processing')}}</a>
          </li>
        </ul>
      </nav>
    </div>

    <div class="table-wrapper" ref="tableWrapper">
      <table
        class="table m-t-5 is-striped is-fullwidth"
        ref="table"
        v-if="$store.getters['options/edge_processing'].length"
      >
        <thead>
          <tr>
            <th>{{ $t("form.name") }}</th>
            <th>{{ $t("form.type") }}</th>
            <th>{{ $t("form.code") }}</th>
            <th class="has-text-right">{{ $t("form.edit") }}/{{$t('form.remove')}}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="ep in $store.getters['options/edge_processing']" :key="ep.id">
            <th>
              <nuxt-link
                :to="
                  localePath({
                    name: 'office-products-glass-edge-processing-id',
                    params: { id: ep.id }
                  })
                "
              >{{ ep.name }}</nuxt-link>
            </th>
            <td>{{ ep.type }}</td>
            <td>{{ ep.code }}</td>
            <td class="has-text-right">
              <nuxt-link
                :to="
                  localePath({
                    name: 'office-products-glass-edge-processing-id',
                    params: { id: ep.id }
                  })
                "
                class="button is-link is-small m-r-2"
              >
                <i class="mdi mdi-pencil"></i>
              </nuxt-link>
              <button
                @click="removeItem(ep.id)"
                class="button is-small is-danger"
                :class="{'is-loading': removeLoading === ep.id}"
              >
                <i class="mdi mdi-trash-can-outline"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-else class="m-t-6">{{$t('message.no_data')}}</div>
    </div>
    <span
      v-if="showSwipeIcon"
      class="mdi mdi-gesture-swipe-horizontal has-text-primary"
      style="font-size: 25px"
    ></span>
  </div>
</template>

<script>
export default {
  data() {
    return {
      removeLoading: false
    };
  },

  computed: {
    showSwipeIcon() {
      return (
        this.isMounted &&
        this.$refs.table &&
        this.$refs.table.scrollWidth > this.$refs.tableWrapper.clientWidth
      );
    }
  },

  methods: {
    async removeItem(id) {
      if (confirm(this.$t("message.are_you_sure"))) {
        this.removeLoading = id;

        try {
          await this.$api.deleteEdgeProcessing(id);
          this.$store.commit("glass/settings/edge_processing/REMOVE_ITEM", id);
        } catch (e) {
          this.handleFormError(e.response.data);
        }

        this.removeLoading = false;
      }
    }
  }
};
</script>




// WEBPACK FOOTER //
// resources/nuxt/pages/office/products/glass/edge-processing/index.vue